var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import styled from 'styled-components';
import mantrisIcon from '../../assets/images/icons/collections/icon-mantris.png';
import watchDogsIcon from '../../assets/images/icons/collections/icon-watch-dogs.png';
import Accordion from '../common/accordion';
import IconCheckbox from './icon-checkbox';
export default function SetForm(_a) {
    var value = _a.value, setValue = _a.setValue;
    var t = useI18n().t;
    function onChange(template) {
        var _value = __spreadArray([], value, true);
        var index = _value.indexOf(template);
        if (index === -1) {
            _value.push(template);
        }
        else {
            _value.splice(index, 1);
        }
        setValue(_value);
    }
    return (_jsx(Accordion, { count: value.length, defaultValue: true, height: 64, title: t('filters.set'), children: _jsxs(Container, { children: [_jsx(IconCheckbox, { hidden: value.length > 0 && !value.includes(1), icon: mantrisIcon, noneSelected: value.length === 0, onChange: function () { return onChange(1); }, value: value.includes(1) }), _jsx(IconCheckbox, { hidden: value.length > 0 && !value.includes(2), icon: watchDogsIcon, noneSelected: value.length === 0, onChange: function () { return onChange(2); }, value: value.includes(2) })] }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-start;\n  padding: 0 24px;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-start;\n  padding: 0 24px;\n  width: 100%;\n"])));
var templateObject_1;
